import React from 'react'

import { TabelaColuna, TabelaDados } from 'src/componentes'

export const colunaSituacao = (): TabelaColuna => ({
  Chave: 'siuacao',
  Texto: 'Situação',
  StyleColuna: { width: 100, paddingInline: 10 },
  Renderizar: (linha: TabelaDados) => <>{linha.situacaoFinanceira}</>
})
